import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import CheckoutForm from "./CheckoutForm";

const CardPaymentPopup = ({
  onClose,
  paymentModel,
  getPaymentMain,
  patientInfo,
}) => {
  const options = {
    mode: "payment",
    amount: 1099,

    currency: "usd",
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  const [stripePromise, setStripePromise] = useState(null);


  useEffect(() => {
    (async () => {
      try {
        let stripePromise = await loadStripe(
          "pk_test_51PCI1JP4jUVGCToskwKYzTsvBDFExG4w82UGPTgG1YqBPACh6SsIIhVyjCAGCngwJscVeQlcFsWQw0C5B3ozxjln00BSriZbWS"
        );
        setStripePromise(stripePromise);
      } catch (error) {
        ErrorHandlingMessage(error);
      }
    })();
  }, []);

  return (
    <div
      data-te-modal-init
      className="fixed left-0 top-0 z-[10] h-full w-full overflow-y-auto overflow-x-hidden outline-none"
      id="exampleModalScrollable"
      tabIndex={-1}
      aria-labelledby="exampleModalScrollableLabel"
      style={{ display: "block" }}
      aria-modal="true"
      role="dialog"
      data-te-open="true"
    >
      <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
      <div
        data-te-modal-dialog-ref
        className="pointer-events-none flex items-center relative h-[calc(100%-1rem)] w-auto translate-y-[-50px] transition-all duration-300 ease-in-out min-[375px]:mx-auto min-[375px]:mt-2 min-[375px]:max-w-[375px] min-[375px]:max-w-[375px] min-[375px]:max-w-[375px] transform-none opacity-100"
      >
        <div className="pointer-events-auto relative flex max-h-[100%] w-full flex-col overflow-hidden rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600">
          <div className="flex items-center justify-between flex-shrink-0 p-4 ">
            <h5
              className="text-xl font-medium leading-normal text-neutral-800 dark:text-neutral-200"
              id="exampleModalScrollableLabel"
            >
              Payment
            </h5>
            <button
              onClick={() => onClose()}
              type="button"
              className="box-content border-none rounded-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
              data-te-modal-dismiss
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="relative overflow-y-auto">
            <div className="grid grid-cols-12 ">
              <div className="col-span-12 p-3 bg-gray-100">
                {stripePromise && (
                  <Elements
                    stripe={stripePromise}
                    options={{ ...options, appearance: { theme: "flat" } }}
                  >
                    <CheckoutForm
                      patientInfo={patientInfo}
                      onClose={onClose}
                      paymentModel={paymentModel}
                    />
                  </Elements>
                )}
              </div>
            </div>
          </div>
          {/* <div className="flex flex-wrap items-center justify-end flex-shrink-0 p-4 border-t-2 border-opacity-100 rounded-b-md border-neutral-100 dark:border-opacity-50">

                        <button onClick={onClose} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2" >
                            Cancel
                        </button>
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default CardPaymentPopup;
